import { Store } from "@tanstack/react-store";
import { YantraStatus } from "../../hooks/useWebSocket";

interface IStatusStore {
  status: YantraStatus;
  isDisabled: boolean;
  activeExecutionId: string;
  activeYantraId: string;
}

const initialState: IStatusStore = {
  status: "COLLECTING_BETS",
  isDisabled: true,
  activeExecutionId: "",
  activeYantraId: "",
};

const statusStore = new Store(initialState);

const getActiveExecutionId = () => {
  return statusStore.state.activeExecutionId;
};

const setStatus = (status: YantraStatus) => {
  statusStore.setState((state) => {
    let isDisabled;
    switch (status) {
      case "COLLECTING_BETS":
        isDisabled = true;
        break;
      default:
        isDisabled = false;
        break;
    }
    return {
      ...state,
      status: status,
      isDisabled: isDisabled,
    };
  });
};

const setActiveExecution = (executionId: string, yantraId: string) => {
  statusStore.setState((state) => {
    return {
      ...state,
      activeExecutionId: executionId,
      activeYantraId: yantraId,
    };
  });
};

export { statusStore, setStatus, setActiveExecution, getActiveExecutionId };
